import './cookshack/style';
import FormStructure from './cookshack/form_structure';

export default FormStructure;